<div *ngIf="!loading" class="container d-flex justify-content-center">
    <div *ngIf="inviteError">
        <h2>{{ inviteErrorMessage }}</h2>
        <elight-progress-button color="accent" (clicked)="navigateToLogin()"
            >To Login Page
        </elight-progress-button>
    </div>
    <div *ngIf="!inviteError">
        <div *ngIf="!userExists" class="d-flex flex-column mt-4 form-wrapper">
            <h2>Register</h2>

            <h6>Welcome to the eLight App. Please create a password.</h6>

            <form
                [formGroup]="registerForm"
                (ngSubmit)="onRegisterFormSubmit()"
            >
                <div>
                    <mat-form-field class="w-100">
                        <input
                            matInput
                            aria-label="Password"
                            placeholder="Password"
                            formControlName="password"
                            autocomplete="new-password"
                            name="password"
                            type="password"
                        />
                        <mat-error
                            *ngIf="
                                registerForm.controls.password.hasError(
                                    'required'
                                )
                            "
                        >
                            Password is required
                        </mat-error>
                        <mat-error
                            *ngIf="
                                registerForm.controls.password.hasError(
                                    'minlength'
                                )
                            "
                        >
                            Password must contain at least 8 characters
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="mt-3">
                    <mat-form-field class="w-100">
                        <input
                            matInput
                            aria-label="Confirm Password"
                            placeholder="Confirm Password"
                            formControlName="passwordConfirm"
                            autocomplete="new-password"
                            name="password-confirm"
                            type="password"
                        />
                        <mat-error
                            *ngIf="
                                registerForm.controls.passwordConfirm.hasError(
                                    'required'
                                )
                            "
                        >
                            Field is required
                        </mat-error>
                        <mat-error
                            *ngIf="
                                registerForm.controls.passwordConfirm.hasError(
                                    'mismatch'
                                )
                            "
                        >
                            Passwords should match
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="mt-3">
                    <mat-form-field class="w-100">
                        <input
                            matInput
                            aria-label="Name"
                            placeholder="Name"
                            formControlName="displayName"
                            name="name"
                        />
                        <mat-error
                            *ngIf="
                                registerForm.controls.displayName.hasError(
                                    'required'
                                )
                            "
                        >
                            Name is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div
                    *ngIf="hasError"
                    class="form-error-row d-flex align-items-center mb-3"
                >
                    <mat-icon>error_outline</mat-icon>
                    <span>Wrong username or password.</span>
                </div>

                <div class="mt-4">
                    <elight-progress-button
                        color="accent"
                        type="submit"
                        [inProgress]="inProgress"
                        [disabled]="!registerForm.valid"
                        >Register
                    </elight-progress-button>
                </div>
            </form>
        </div>
        <div *ngIf="userExists" class="d-flex flex-column mt-4 form-wrapper">
            <h2>Join the division</h2>
            <elight-progress-button
                color="accent"
                [inProgress]="inProgress"
                (clicked)="onRegisterFormSubmit()"
                >Join
            </elight-progress-button>
        </div>
    </div>
</div>
